;(function() {

  function load() {
    button.removeEventListener('click', load)

    // normal install script
    ;(function(d){var s = d.createElement("script");s.setAttribute("data-account", "fhAckt83B1");s.setAttribute("src", "https://cdn.userway.org/widget.js");(d.body || d.head).appendChild(s);})(document)

    /* Open UserWay accessibility menu on init */
    /* https://codepen.io/userway/pen/QYRGqx */
    document.addEventListener('userway:init_completed', function (event) {
      var instance = event.detail.userWayInstance
      instance.widgetOpen()
    })
  }

  // build button
  const button = document.createElement('button')
  button.id = 'userway-facade-button'
  button.setAttribute('aria-label', 'Click to open UserWay ADA widget')
  button.innerHTML = '<img width="46" height="46" data-uw-rm-ignore="" class="ui_w" role="presentation" alt="UserWay logo" src="https://cdn.userway.org/widgetapp/images/body_wh.svg">'

  // build styles
  const style = document.createElement('style')
  style.innerHTML = `
    #userway-facade-button { padding: 3px; display: flex; justify-content: center; align-items: center; background-color: rgb(0, 119, 192); border-radius: 200px; height: 46px; width: 46px; position: fixed; bottom: 13px; left: 13px; z-index: 1048; cursor: pointer; }
    #userway-facade-button:hover { transform: scale(1.1) }
    @media (min-width: 680px) {
      #userway-facade-button {
        bottom: 13px;
        left: 13px;
      }
    }
  `

  // arm button
  button.addEventListener('click', load)

  // build container, add elements
  const div = document.createElement('div')
  div.appendChild(button)
  div.appendChild(style)

  // add container to body
  document.body.appendChild(div)
})()
